import { useState, useEffect, useCallback } from 'react';

const useCountdownTimer = (
  initialMinutes: number,
  autoStart: boolean = true
) => {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60);
  const [isRunning, setIsRunning] = useState<boolean>(autoStart);

  const restartTimer = useCallback(() => {
    setTimeLeft(initialMinutes * 60);
    setIsRunning(true);
  }, [initialMinutes]);

  useEffect(() => {
    if (!isRunning) return;

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(intervalId);
          setIsRunning(false);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [isRunning]);

  const getRemainingTime = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return { minutes, seconds };
  };

  return { getRemainingTime, restartTimer, isRunning };
};

export default useCountdownTimer;
